import React, { Component } from "react";
import _ from "i18n";
import styles from "./HomePage.local.scss";

import * as lottieWeb from "lottie-web";
import Footer from "../Layout/Footer/Footer";
import { S3_FOLDER_URL_PROD, APP_ENV } from "../../config";
import { connect } from "react-redux";
import Lottie from "react-lottie";
import * as data from "../Common/lottie-animations/data.json";
import { inIframe } from "../../utils";
import { NotificationBar } from "../Common/Notification/NotificationBar";

class HomePage extends Component {
  anim = null;
  defaultOptions = {
    loop: true,
    autoplay: true
  };
  componentDidMount() {
    this.intiAnimation();
  }

  intiAnimation = () => {
    if (this.anim) {
      this.anim.destroy();
    }
    this.anim = lottieWeb.loadAnimation({
      container: this.refs.animationContainer,
      renderer: "svg",
      loop: 1,
      autoplay: true,
      path: `${S3_FOLDER_URL_PROD}/accounting/assets/animations/${"data"}-header.json`
    });
  };

  componentWillUnmount() {
    if (this.anim) {
      this.anim.destroy();
    }
  }

  handleClickToPause = () => {
    if (!this.anim) {
      return;
    }
    if (this.anim.isPaused) {
      this.anim.goToAndPlay(0);
    } else {
      this.anim.pause();
    }
  };

  render() {
    let application = "data";
    return (
      <div className={styles.homePage} id={styles.homPage}>
        {inIframe() === false && (
          <NotificationBar
            message={_("notifyUsingUa")}
            isUaNotification={true}
            theme="lightOrange"
          />
        )}
        <div className={styles.sendingHeader}>
          <div className={styles.sendingHeader__title}>
            <h3>{_("Gérer vos dashboards")}</h3>
            <h4>
              {_("à l'apparence de votre communauté")}{" "}
              <span>{_("avec peu d'effort!")}</span>
            </h4>
          </div>
          <div
            className={styles.sendingHeader__animation}
            ref={"animationContainer"}
            onClick={this.handleClickToPause}
          >
            {APP_ENV === "local" ? (
              <Lottie
                options={{ ...this.defaultOptions, animationData: data }}
              />
            ) : null}
          </div>
          <video controls poster={`/img/${application}-poster.png`}>
            <source
              src={`${S3_FOLDER_URL_PROD}/accounting/assets/${application}.mp4`}
              type="video/mp4"
            />
          </video>
        </div>
        {!this.props.withoutHeader ? <Footer /> : null}
      </div>
    );
  }
}
// Connected Component
const mapStateToProps = state => ({
  withoutHeader: state.auth.withoutHeader
});

export default connect(mapStateToProps)(HomePage);



// WEBPACK FOOTER //
// ./src/components/home/HomePage.js